<template>
  <!-- <basic-container >  f0f2f5 -->
  <div class="card-container" style="background: #fff">
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康管理护士工作站</el-breadcrumb-item>
        <el-breadcrumb-item>线上健康管理</el-breadcrumb-item>
        <el-breadcrumb-item>健康动态数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>

    <div style="height: 50px; padding-top: 10px">
      <el-button-group>
        <el-button class="healthButton healthActive" @click="click(0)">健康动态数据</el-button>
        <el-button class="healthButton" @click="click(1)">数字档案完成度</el-button>
        <el-button class="healthButton" @click="click(2)">健康管理方案</el-button>
        <el-button class="healthButton" @click="click(3)">认知行为治疗状态</el-button>
        <el-button class="healthButton" @click="click(4)">消息推送</el-button>
      </el-button-group>
    </div>

    <div class="card-row">
      <div class="card card01">
        <div class="card-row" style="font-size: 20px; font-weight: bold; margin-bottom: 2vh">
          {{ info.name }}
        </div>
        <div class="card02" style="font-size: 14px">
          <div>性别：{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}</div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card02" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>身高|体重：{{ info.height ? info.height : "..." }}cm/{{ info.weight ? info.weight : "..." }}kg</div>
        </div>
        <div class="card02" style="margin-bottom: 0vh; margin-top: 7vh">
          <div style="font-size: 18px; font-weight: bold; margin-bottom: 10px">用户标签</div>
          <!-- <div>
            <el-button
              type="primary"
              style="font-size: 15px"
              @click="toLabelTextShow"
              >新 增</el-button
            >
          </div> -->
        </div>
        <div class="card-row">
          <div class="label01" v-for="(item, index) in labels" :key="index">
            {{ item }}
            <span @click="delLabel(index)">×</span>
          </div>
          <div class="label-placeholder" v-if="labels.length === 0">
            &nbsp;
            <!-- 空格占位 -->
          </div>
        </div>
        <div class="grid_1f_2a" v-if="labelTextShow">
          <el-input v-model="labelText" placeholder="请输入标签"></el-input>
          <div>
            <el-button type="primary" style="font-size: 15px" @click="addLabel()">保存</el-button>
            <el-button style="font-size: 15px" @click="notLabelTextShow">取消</el-button>
          </div>
        </div>
      </div>
      <div class="card card01">
        <div style="position: relative">
          <div class="buttons">
            <el-date-picker v-model="thatWeek" type="week" format="yyyy 第 WW 周" placeholder="选择周" style="margin-right: 12px" @change="chickDay(3)"></el-date-picker>
            <el-button :type="isSelected === 2 ? 'success' : 'default'" @click="chickDay(2)">上周</el-button>
            <el-button :type="isSelected === 1 ? 'success' : 'default'" @click="chickDay(1)">本周</el-button>
          </div>
          <div style="font-size: 18px; font-weight: bold; margin-bottom: 1vh">用户周报 - 数据达标</div>
          <div style="font-size: 14px">
            统计时间：
            <!-- {{ recent.date }} 0点 ~ {{ recent.end }} -->
          </div>
          <div class="table1" style="width: auto; min-width: 700px">
            <div class="t1_data2">
              <div>体质指数</div>
              <div>心率</div>
              <div>血氧</div>
              <div>血糖</div>
              <!-- <div>胆固醇</div> -->
              <div>睡眠</div>
            </div>
            <div class="t1_data2" style="font-weight: bold">
              <div :style="{ color: report.bmi === 2 ? 'red' : report.bmi === 1 ? 'green' : '' }">
                {{ report.bmi == 1 ? "达标" : report.bmi == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.heart === 2 ? 'red' : report.heart === 1 ? 'green' : '' }">
                {{ report.heart == 1 ? "达标" : report.heart == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.bo === 2 ? 'red' : report.bo === 1 ? 'green' : '' }">
                {{ report.bo == 1 ? "达标" : report.bo == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.bs === 2 ? 'red' : report.bs === 1 ? 'green' : '' }">
                {{ report.bs == 1 ? "达标" : report.bs == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.sleep === 2 ? 'red' : report.sleep === 1 ? 'green' : '' }">
                {{ report.sleep == 1 ? "达标" : report.sleep == 2 ? "不达标" : "..." }}
              </div>
            </div>
            <div class="t1_data2">
              <div>皮肤温度</div>
              <div>呼吸</div>
              <div>血压</div>
              <div>尿酸</div>
              <!-- <div>心电图</div> -->
              <div>运动</div>
              <!-- <div>情绪压力</div>
              <div>中医体质</div> -->
            </div>
            <div class="t1_data2" style="font-weight: bold; margin-bottom: 0vh">
              <div :style="{ color: report.bt === 2 ? 'red' : report.bt === 1 ? 'green' : '' }">
                {{ report.bt == 1 ? "达标" : report.bt == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.breath === 2 ? 'red' : report.breath === 1 ? 'green' : '' }">
                {{ report.breath == 1 ? "达标" : report.breath == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.bp === 2 ? 'red' : report.bp === 1 ? 'green' : '' }">
                {{ report.bp == 1 ? "达标" : report.bp == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.ua === 2 ? 'red' : report.ua === 1 ? 'green' : '' }">
                {{ report.ua == 1 ? "达标" : report.ua == 2 ? "不达标" : "..." }}
              </div>
              <div :style="{ color: report.move === 2 ? 'red' : report.move === 1 ? 'green' : '' }">
                {{ report.move == 1 ? "达标" : report.move == 2 ? "不达标" : "..." }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-row">
      <div class="card card03">
        <div class="card02" style="margin: 0px">
          <div>
            <div style="font-size: 18px; font-weight: bold; margin-bottom: 1vh">今日实时数据</div>
            <div style="font-size: 14px">统计时间：{{ recent.date }} 0点 ~ {{ recent.end }}</div>
            <div class="table1">
              <div class="t1_data">
                <div>心率</div>
                <div>血压</div>
                <div>血氧</div>
                <div>体温</div>
                <div>血糖</div>
              </div>
              <div class="t1_data" style="font-weight: bold">
                <div>{{ recent.heartRate ? recent.heartRate : "..." }}</div>
                <div>{{ recent.sys ? recent.sys : "..." }}/{{ recent.dia ? recent.dia : "..." }}</div>
                <div>{{ recent.bo ? recent.bo : "..." }}</div>
                <div>{{ recent.bt ? recent.bt : "..." }}</div>
                <div>{{ recent.bs ? recent.bs : "..." }}</div>
              </div>
              <div class="t1_data" style="margin-bottom: 0vh">
                <div>{{ recent.hrDate ? recent.hrDate : "..." }}</div>
                <div>{{ recent.bpDate ? recent.bpDate : "..." }}</div>
                <div>{{ recent.boDate ? recent.boDate : "..." }}</div>
                <div>{{ recent.btDate ? recent.btDate : "..." }}</div>
                <div>{{ recent.bsDate ? recent.bsDate : "..." }}</div>
              </div>
            </div>
            <div style="font-size: 18px; font-weight: bold; margin-top: 10vh; margin-bottom: 1vh">步数与热量消耗</div>
            <div style="font-size: 14px; color: #1e244c; display: flex">
              <div style="margin-right: 1vw; margin-bottom: 1vh">🏃‍♀️步数：{{ today_mo.moSn }}步/6000步</div>
              <div>💪活动消耗：{{ today_mo.moCa }}千卡/400千卡</div>
            </div>
            <div style="font-size: 14px; color: #1e244c; display: flex">运动贵在坚持，加油哦~</div>
          </div>
          <div>
            <div style="font-size: 18px; font-weight: bold">今日数据汇总</div>
            <div class="table2">
              <div class="t2_data">
                <div>项目</div>
                <div>累计次数</div>
                <div>平均</div>
                <div>最高</div>
                <div>最低</div>
              </div>
              <div class="t2_data">
                <div>心率</div>
                <div>{{ today.bpAndHr.count_hr }} 次</div>
                <div>{{ today.bpAndHr.avg_hr }}</div>
                <div>{{ today.bpAndHr.max_hr }}</div>
                <div>{{ today.bpAndHr.min_hr }}</div>
              </div>
              <div class="t2_data">
                <div>血压</div>
                <div>{{ today.bpAndHr.count_dia }} 次</div>
                <div>{{ today.bpAndHr.avg_sys }} / {{ today.bpAndHr.avg_dia }}</div>
                <div>{{ today.bpAndHr.max_sys }} / {{ today.bpAndHr.max_dia }}</div>
                <div>{{ today.bpAndHr.min_sys }} / {{ today.bpAndHr.min_dia }}</div>
              </div>
              <div class="t2_data">
                <div>血氧</div>
                <div>{{ today.bo.count_bo }} 次</div>
                <div>{{ today.bo.avg_bo }}</div>
                <div>{{ today.bo.max_bo }}</div>
                <div>{{ today.bo.min_bo }}</div>
              </div>
              <div class="t2_data">
                <div>体温</div>
                <div>{{ today.bt.count_bt }} 次</div>
                <div>{{ today.bt.avg_bt }}</div>
                <div>{{ today.bt.max_bt }}</div>
                <div>{{ today.bt.min_bt }}</div>
              </div>
              <div class="t2_data">
                <div>血糖</div>
                <div>{{ today.bs.count_bs }} 次</div>
                <div>{{ today.bs.avg_bs }}</div>
                <div>{{ today.bs.max_bs }}</div>
                <div>{{ today.bs.min_bs }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background: #fff; margin-top: 14px">
      <el-button-group>
        <el-button :class="healthButton == 1 ? 'healthButton healthActive' : 'healthButton'">健康日报</el-button>
        <el-button :class="healthButton == 2 ? 'healthButton healthActive' : 'healthButton'">健康周报</el-button>
        <el-button :class="healthButton == 3 ? 'healthButton healthActive' : 'healthButton'">健康月报</el-button>
      </el-button-group>
      <!-- 心率 -->
      <div class="card-row2">
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="heartDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="heartSearch()">查询</el-button>
          </div>
          <div
            id="heartChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>
        <!-- 血压 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-button :type="bpMedicalData === 1 ? 'success' : 'default'" @click="chickBpMedicalData(1)">医疗数据</el-button>
            <el-button :type="bpNotMedicalData === 1 ? 'success' : 'default'" @click="chickBpNotMedicalData(1)">非医疗数据</el-button>
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="bpDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="bpSearch()">查询</el-button>
          </div>
          <div
            id="bpChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>
        <!-- 血糖 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-button :type="bsMedicalData === 1 ? 'success' : 'default'" @click="chickBsMedicalData(1)">医疗数据</el-button>
            <el-button :type="bsNotMedicalData === 1 ? 'success' : 'default'" @click="chickBsNotMedicalData(1)">非医疗数据</el-button>
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="bsDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="bsSearch()">查询</el-button>
          </div>
          <div
            id="bsChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>
        <!-- 血氧 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-button :type="boMedicalData === 1 ? 'success' : 'default'" @click="chickBoMedicalData(1)">医疗数据</el-button>
            <el-button :type="boNotMedicalData === 1 ? 'success' : 'default'" @click="chickBoNotMedicalData(1)">非医疗数据</el-button>
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="boDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="boSearch()">查询</el-button>
          </div>
          <div
            id="boChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 温度 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="btDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="btSearch()">查询</el-button>
          </div>
          <div
            id="btChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 睡眠 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="sleepDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="sleepSearch()">查询</el-button>
          </div>
          <div
            id="sleepChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>

        <!-- 步数 -->
        <div class="card dataChart" style="position: relative">
          <div class="dataButtons">
            <el-date-picker style="margin-left: 10px; margin-right: 10px" v-model="moDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button @click="moSearch()">查询</el-button>
          </div>
          <div
            id="moChart"
            :style="{
              width: '100%',
              height: 'auto',
              minHeight: '370px',
              minWidth: '770px',
            }"
          ></div>
        </div>
      </div>
    </div>

    <!-- <div class="card-row">
      <div class="card card03">
        <div class="card-row" style="height: 100px">范裕晨</div>
      </div>

      <div class="card card-50" style="position: relative">
        <div id="columnChart1" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-20">
        <div id="pieChart1" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
    </div>
    <div class="card-row">
      <div class="card card-20">
        <div id="columnChart2" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-20">
        <div id="pieChart2" :style="{ width: '100%', height: '40vh' }"></div>
      </div>
      <div class="card card-50" style="position: relative"></div>
    </div> -->
  </div>
  <!-- </basic-container> -->
</template>

<script>
import { getLabel, addLabel, delLabel, getDataDetail, getWatchDetail, getComplianceReportByThatWeek, getSleepData } from "@/api/health/manage";
import { heDataValueNew, bpDataValueNew } from "../../api/health/bpmeterdata";
import { bsDataValueNew, boDataValueNew, btDataValueNew, moDataValueNew } from "../../api/health/datashow";

export default {
  name: "ThreeCardLayout",
  data() {
    return {
      wxUserid: this.$route.query.wxUserId,
      info: {},
      device: {},
      recent: {},
      labels: [],
      labelText: "",
      labelTextShow: false,
      isSelected: 3, // 1七天 2三天 3今天
      today: {
        bpAndHr: {
          avg_dia: "",
          avg_hr: "",
          avg_sys: "",
          count_dia: "0",
          count_hr: "0",
          count_sys: "0",
          max_dia: "",
          max_hr: "",
          max_sys: "",
          min_dia: "",
          min_hr: "",
          min_sys: "",
        },
        bo: {
          avg_bo: "",
          count_bo: "0",
          max_bo: "",
          min_bo: "",
        },
        bs: {
          avg_bs: "",
          count_bs: "0",
          max_bs: "",
          min_bs: "",
        },
        bt: {
          avg_bt: "",
          count_bt: "0",
          max_bt: "",
          min_bt: "",
        },
      },
      today_mo: {
        moSn: 0,
        moCa: 0,
      },
      healthButton: 1,
      params: {
        wxUserId: "",
        week: "",
        type: "1",
        jkStatus: "",
        beginDate: "",
        endDate: "",
      },
      bps: [],
      bos: [],
      bss: [],
      bts: [],
      mos: [],
      hearts: [],
      heartDate: [],
      bpDate: [],
      bsDate: [],
      boDate: [],
      btDate: [],
      moDate: [],
      thatWeek: "",
      report: {},
      sleeps: [],
      sleepDate: [],
      bpMedicalData: 1,
      bpNotMedicalData: 1,
      bsMedicalData: 1,
      bsNotMedicalData: 1,
      boMedicalData: 1,
      boNotMedicalData: 1,
    };
  },
  created() {
    this.params.wxUserId = this.$route.query.wxUserId || ""; // eslint-disable-line no-unused-vars
    this.params.week = this.$route.query.meterDate || ""; // eslint-disable-line no-unused-vars
    this.params.jkStatus = this.$route.query.jkStatus || "";
    this.params.beginDate = this.$route.query.beginDate || "";
    this.params.endDate = this.$route.query.endDate || "";
  },
  mounted() {
    this.onload();
    this.chickDay(1);
    this.getLabel();
  },
  methods: {
    onload() {
      const wxUserId = this.$route.query.wxUserId;
      const imei = this.$route.query.imei;

      let end = new Date();
      end = end.toISOString().split("T")[0];
      let start = new Date();
      start.setDate(start.getDate() - 365);
      start = start.toISOString().split("T")[0];

      this.params.beginDate = start;
      this.params.endDate = end;

      getDataDetail(wxUserId).then((res) => {
        this.info = res.data.userJk;
        this.recent = res.data.recent;
        this.today = res.data.today;
        this.today_mo = res.data.today_mo;
      });

      getWatchDetail(wxUserId, imei).then((res) => {
        this.device = res.data;
      });

      // 心率数据
      heDataValueNew(this.params).then((res) => {
        this.hearts = res.data;
        this.heartChart(0);
      });

      // 血压数据
      bpDataValueNew(this.params).then((res) => {
        this.bps = res.data;
        this.bpChart(0);
      });

      // 血氧数据
      boDataValueNew(this.params).then((res) => {
        this.bos = res.data;
        this.boChart(0);
      });

      // 血糖数据
      bsDataValueNew(this.params).then((res) => {
        this.bss = res.data;
        this.bsChart(0);
      });

      // 血氧数据
      boDataValueNew(this.params).then((res) => {
        this.bos = res.data;
        this.boChart(0);
      });

      // 温度
      btDataValueNew(this.params).then((res) => {
        this.bts = res.data;
        this.btChart(0);
      });

      // 步数
      moDataValueNew(this.params).then((res) => {
        this.mos = res.data;
        this.moChart(0);
      });

      getSleepData(this.params).then((res) => {
        this.sleeps = res.data;
        this.sleepChart(0);
        console.log(res.data);
      });
    },

    chickDay(index) {
      this.isSelected = index;
      if (index === 1) {
        const date = new Date();
        this.thatWeek = date;
      }
      if (index === 2) {
        const date = new Date();
        date.setDate(date.getDate() - 7);
        this.thatWeek = date;
      }
      const year = this.thatWeek.getFullYear();
      const month = String(this.thatWeek.getMonth() + 1).padStart(2, "0");
      const day = String(this.thatWeek.getDate()).padStart(2, "0");

      getComplianceReportByThatWeek(this.wxUserid, year + "-" + month + "-" + day).then((res) => {
        this.report = res.data;
        console.log(this.report);
      });
    },

    chickBpMedicalData() {
      if (this.bpMedicalData === 1) {
        this.bpMedicalData = 0;
      } else {
        this.bpMedicalData = 1;
      }

      this.bpSearch();
    },

    chickBpNotMedicalData() {
      if (this.bpNotMedicalData === 1) {
        this.bpNotMedicalData = 0;
      } else {
        this.bpNotMedicalData = 1;
      }
      this.bpSearch();
    },

    chickBoMedicalData() {
      if (this.boMedicalData === 1) {
        this.boMedicalData = 0;
      } else {
        this.boMedicalData = 1;
      }

      this.boSearch();
    },

    chickBoNotMedicalData() {
      if (this.boNotMedicalData === 1) {
        this.boNotMedicalData = 0;
      } else {
        this.boNotMedicalData = 1;
      }
      this.boSearch();
    },

    chickBsMedicalData() {
      if (this.bsMedicalData === 1) {
        this.bsMedicalData = 0;
      } else {
        this.bsMedicalData = 1;
      }

      this.bsSearch();
    },

    chickBsNotMedicalData() {
      if (this.bsNotMedicalData === 1) {
        this.bsNotMedicalData = 0;
      } else {
        this.bsNotMedicalData = 1;
      }
      this.bsSearch();
    },

    heartSearch() {
      if (this.heartDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.heartDate[0] || "";
        this.params.endDate = this.heartDate[1] || "";
      }
      heDataValueNew(this.params).then((res) => {
        this.hearts = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.heartChart(index);
      });
    },

    bpSearch() {
      if (this.bpDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.bpDate[0] || "";
        this.params.endDate = this.bpDate[1] || "";
      }
      this.params.bpMedicalData = this.bpMedicalData;
      this.params.bpNotMedicalData = this.bpNotMedicalData;
      bpDataValueNew(this.params).then((res) => {
        this.bps = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.bpChart(index);
      });
    },

    bsSearch() {
      if (this.bsDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.bsDate[0] || "";
        this.params.endDate = this.bsDate[1] || "";
      }
      this.params.bsMedicalData = this.bsMedicalData;
      this.params.bsNotMedicalData = this.bsNotMedicalData;
      bsDataValueNew(this.params).then((res) => {
        this.bss = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.bsChart(index);
      });
    },

    boSearch() {
      if (this.boDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.boDate[0] || "";
        this.params.endDate = this.boDate[1] || "";
      }
      this.params.boMedicalData = this.boMedicalData;
      this.params.boNotMedicalData = this.boNotMedicalData;
      boDataValueNew(this.params).then((res) => {
        this.bos = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.boChart(index);
      });
    },

    btSearch() {
      if (this.btDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.btDate[0] || "";
        this.params.endDate = this.btDate[1] || "";
      }
      btDataValueNew(this.params).then((res) => {
        this.bts = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.btChart(index);
      });
    },

    moSearch() {
      if (this.moDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.moDate[0] || "";
        this.params.endDate = this.moDate[1] || "";
      }
      moDataValueNew(this.params).then((res) => {
        this.mos = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        this.moChart(index);
      });
    },

    sleepSearch() {
      if (this.sleepDate == null) {
        this.params.beginDate = "";
        this.params.endDate = "";
      } else {
        this.params.beginDate = this.sleepDate[0] || "";
        this.params.endDate = this.sleepDate[1] || "";
      }
      getSleepData(this.params).then((res) => {
        this.sleeps = res.data;
        let index = 0;
        if (this.params.beginDate === this.params.endDate && this.params.beginDate !== "") {
          index = 1;
        }
        console.log(index);
        console.log(this.params);
        this.sleepChart(index);
      });
    },

    getLabel() {
      getLabel(this.wxUserid).then((res) => {
        this.labels = res.data;
      });
    },

    addLabel() {
      if (this.labelText === "null" || this.labelText === "") {
        this.$message({
          type: "error",
          message: "输入为空!",
        });
      } else {
        addLabel(this.wxUserid, this.labelText).then((res) => {
          this.labels = res.data;
          this.labelText = "";
        });
        this.$message({
          type: "success",
          message: "添加成功!",
        });
      }
    },

    delLabel(index) {
      this.$confirm("确定删除该用户标签?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delLabel(this.wxUserid, index).then((res) => {
          this.labels = res.data;
        });
        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    },

    lineChart1(day) {
      const date = [];
      const elec = [];
      const isElec = [];
      // 准备数据
      for (let i = 1; i < this.elec.length; i++) {
        if (this.elec[i].elec !== this.elec[i - 1].elec) {
          date.push(this.elec[i].date);
          if (this.elec[i].isElec === "0") {
            elec.push(this.elec[i].elec);
            isElec.push(null);
          } else {
            elec.push(null);
            isElec.push(this.elec[i].elec);
          }
        }
      }

      const myChart = this.$echarts.init(document.getElementById("lineChart1"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "5%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "电量使用详情",
          left: "left",
          textStyle: {
            fontSize: 15,
            // fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // 过滤掉值为null或undefined的系列
            const validParams = params.filter((item) => item.value !== null && item.value !== undefined);
            let result = "";
            if (validParams.length > 0) {
              result = validParams[0].axisValue + "<br/>";
              validParams.forEach((item) => {
                result += `${item.marker}${item.seriesName}: ${item.value}`;
              });
            }
            return result;
          },
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: date,
          axisLabel: {
            // 修改x轴标签
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "电量",
            type: "line",
            data: elec,
            stack: "总量",
            // areaStyle: {},
            symbol: elec.length === 1 ? "" : "none",
            lineStyle: {
              color: "green",
              width: 2,
              type: "solid",
            },
          },
          {
            name: "电量(充电中)",
            type: "line",
            data: isElec,
            stack: "总量",
            // areaStyle: {},
            symbol: isElec.length === 1 ? "" : "none",
            lineStyle: {
              color: "red",
              width: 2,
              type: "dotted",
            },
          },
        ],
        color: ["green", "red"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    // day: 1-x轴横向显示 不显示年月日  其他-纵向显示
    heartChart(day) {
      const myChart = this.$echarts.init(document.getElementById("heartChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "心率数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.hearts.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 30,
          max: 200,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "心率",
            type: "line",
            data: this.hearts.map((v) => v.avgHeartRate),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            stack: "总量",
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#1BC1A4",
              width: 1,
              type: "solid",
            },
          },
        ],
        color: ["#1BC1A4"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    bpChart(day) {
      const devices = ["", "手动录入", "复云手表", "一体机", "脉搏波血压计", "大的血压站", "小的房颤血压计", "数字人", "小的血压计", "心电图血压计", "蓝牙手表", "4G手表", "三诺血压计", "wifi血压计", "4G手表(BT01)", "蓝牙气囊", "辰浩血压计", "4G气囊手表", "蓝牙光电"];

      const sys_dia = [];
      for (let i = 0; i < this.bps.length; i++) {
        const diff = this.bps[i].avgSystolic - this.bps[i].avgDiastolic;
        sys_dia.push(diff);
      }

      const myChart = this.$echarts.init(document.getElementById("bpChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "血压数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
          formatter: (params) => {
            const idx = params[0].dataIndex;
            let html = ``;
            if (day === 1) {
              html = `${idx}<br>`;
              const device = devices[this.bps[idx].deviceType] || "未知";
              html = `设备类型：${device}<br>`;
            }
            params.forEach((p) => {
              html += `${p.marker} ${p.seriesName}: ${p.value}<br>`;
            });
            return html;
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bps.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 180,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "收缩压",
            type: "line",
            data: this.bps.map((v) => v.avgSystolic),
            // symbol: this.hearts.length === 1 ? "" : "none",
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            lineStyle: {
              color: "#738BD6",
              width: 2,
              type: "solid",
            },
            symbol: "circle",
          },
          {
            name: "舒张压",
            type: "line",
            data: this.bps.map((v) => v.avgDiastolic),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#91CC75",
              width: 2,
              type: "solid",
            },
            symbol: "circle",
          },
          {
            name: "压差",
            type: "line",
            data: sys_dia,
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            // symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#FAC857",
              width: 2,
              type: "solid",
            },
            symbol: "circle",
          },
        ],
        color: ["#738BD6", "#91CC75", "#FAC857"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    bsChart(day) {
      const devices = ["", "手动录入", "手表", "一体机设备", "三诺血糖仪(持续监测CGM)", "三合一设备", "三诺4G血糖仪", "app蓝牙手表"];

      const myChart = this.$echarts.init(document.getElementById("bsChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "血糖数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
          formatter: (params) => {
            const idx = params[0].dataIndex;
            let html = ``;
            if (day === 1) {
              html = `${idx}<br>`;
              const device = devices[this.bss[idx].deviceType] || "未知";
              html = `设备类型：${device}<br>`;
            }
            params.forEach((p) => {
              html += `${p.marker} ${p.seriesName}: ${p.value}<br>`;
            });
            return html;
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bss.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 18,
          max: 0,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "血糖",
            type: "line",
            data: this.bss.map((v) => v.avgBsValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#5274CF",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#5274CF"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    boChart(day) {
      const devices = ["", "手动录入", "早期4G手表", "复云手表", "一体机设备", "BT01手表", "app", "蓝牙", "新蓝牙", "4G气囊手表"];

      const myChart = this.$echarts.init(document.getElementById("boChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "血氧数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
          formatter: (params) => {
            const idx = params[0].dataIndex;
            let html = ``;
            if (day === 1) {
              html = `${idx}<br>`;
              const device = devices[this.bos[idx].deviceType] || "未知";
              html = `设备类型：${device}<br>`;
            }
            params.forEach((p) => {
              html += `${p.marker} ${p.seriesName}: ${p.value}<br>`;
            });
            return html;
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bos.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 80,
          max: 110,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "血氧",
            type: "line",
            data: this.bos.map((v) => v.avgBoValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#1BC1A4",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#1BC1A4"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    btChart(day) {
      const myChart = this.$echarts.init(document.getElementById("btChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "体温数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.bts.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 42,
          max: 30,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "体温",
            type: "line",
            data: this.bts.map((v) => v.avgBtValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#FAC857",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#FAC857"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    moChart(day) {
      const myChart = this.$echarts.init(document.getElementById("moChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "运动数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.mos.map((v) => v.meterDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return day === 1 ? value.substring(11, 16) : value;
            },
            // interval: 0,
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: this.mos.length === 0 ? 5000 : undefined,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "步数",
            type: "line",
            data: this.mos.map((v) => v.avgMoValue),
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" },
              ],
            },
            markLine: {
              data: [
                {
                  type: "max",
                  lineStyle: {
                    type: "dashed",
                    color: "#91CC75",
                  },
                  label: {
                    formatter: "最大步数: {c} 步",
                    position: "middle",
                  },
                },
              ],
            },
            // areaStyle: {},
            symbol: this.hearts.length === 1 ? "" : "none",
            lineStyle: {
              color: "#91CC75",
              width: 2,
              type: "solid",
            },
          },
        ],
        color: ["#91CC75"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    sleepChart(day) {
      const myChart = this.$echarts.init(document.getElementById("sleepChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "3%",
          bottom: "1%",
          top: "15%",
          containLabel: true, // 确保坐标轴标签显示在grid区域内
        },
        title: {
          text: "睡眠数据",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666666",
            // fontWeight: "bold",
          },
        },
        // 右上角 转为数据工具 的小图标
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.sleeps.map((v) => v.sleepDate),
          axisLabel: {
            // 修改x轴标签
            formatter: function (value) {
              return value.substring(0, 11);
            },
            interval: "auto",
            rotate: day === 1 ? 0 : 90,
            margin: 7,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: this.mos.length === 0 ? 300 : undefined,
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "睡眠总时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.totalTime),
          },
          {
            name: "浅睡时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.lightTime),
          },
          {
            name: "深睡时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.deepTime),
          },
          {
            name: "快速眼动时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.remTime),
          },
          {
            name: "途清醒时长(分钟)",
            type: "bar",
            data: this.sleeps.map((v) => v.wakeupTime),
          },
        ],
        color: ["#91CC75", "#BC80EC", "#8A2BE2", "#ACAFF0", "#CEBAF5"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    toLabelTextShow() {
      this.labelTextShow = true;
    },

    notLabelTextShow() {
      this.labelTextShow = false;
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/healthmanagement/onlinehealthmanagement",
      });
    },

    click(index) {
      let path = "";
      switch (index) {
        case 0:
          path = "/healthmanagement/healthdata";
          break;
        case 1:
          path = "/healthmanagement/digitalarchives";
          break;
        case 2:
          path = "/healthmanagement/healthplan";
          break;
        case 3:
          path = "/healthmanagement/cognitivebehavioral";
          break;
        case 4:
          path = "/healthmanagement/pushmessages";
          break;
      }
      const parameter = {
        wxUserId: this.wxUserid,
      };
      this.$router.push({
        path: path,
        query: parameter,
      });
    },
  },
};
</script>

<style scoped>
.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 1vw;
}

.card-row2 {
  /* display: flex; */
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 1vw;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card02 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 2vh;
}

.label01 {
  padding: 5px;
  border: 1px solid #b7eb8f;
  background-color: #f6ffed;
  font-size: 13px;
  color: #28b315;
}

.buttons {
  position: absolute;
  right: 1vw;
  z-index: 100;
  opacity: 0.9;
  width: auto;
}

.grid_1f_2a {
  display: grid;
  grid-template-columns: 1fr auto;
  /* margin-bottom: 2vh; */
  gap: 1vw;
}

.card03 {
  flex: 1;
  height: auto;
}

.card04 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.table1 {
  width: 500px;
  height: auto;
  margin: 1vh 0vw;
  border: 1px solid #ccc;
  border-radius: 15px;
  font-size: 14px;
  padding: 2vh 0vw;
  text-align: center;
}

.t1_data {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  margin-bottom: 3vh;
}

.t1_data2 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  margin-bottom: 3vh;
}

.table2 {
  width: auto;
  height: 300px;
  margin: 1vh 0vw;
  /* border: 1px solid #ccc; */
  border-radius: 15px;
  font-size: 14px;
  padding: 30px 0vw;
  text-align: center;
  background-color: #fafafa;
}

.t2_data {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  font-size: 13px;
  border-bottom: 1px solid #e8e8e8;
  padding: 12px 0px;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 1px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
}

.dataChart {
  /* border: 1px solid ; */
  margin-bottom: 1vh;
  border-radius: 0px;
}

.dataButtons {
  position: absolute;
  right: 1vw;
  z-index: 100;
  opacity: 0.9;
  width: auto;
}

.font01 {
  font-size: 17px;
  font-weight: bold;
}

.card-50 {
  flex: 1 1 calc(10% - 1vw);
  height: 43vh;
}

.card-20 {
  flex: 1 1 calc(20% - 1vw);
  height: 43vh;
}

.chart-buttons {
  position: absolute;
  top: 0.5vw; /* 距离顶部距离 */
  right: 1vw; /* 距离右侧距离 */
  z-index: 100; /* 确保按钮在图表上方 */
  opacity: 0.9; /* 可选：轻微透明效果 */
  width: auto;
}

.card-header {
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-total {
  font-size: 24px;
  font-weight: 600;
  margin-top: 8px;
}
.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
</style>
